import router       from '../../app/router/index.js';
import home         from './pages/home/index.vue';
import search       from './pages/search/index.vue';
import searchResult from './pages/searchResult/index.vue';

const routeList = [ {
  path      : '/virusTrip/home',
  component : home
}, {
  path      : '/virusTrip/search',
  component : search,

  meta : {
    needRedirect : true
  }
}, {
  path      : '/virusTrip/searchResult',
  component : searchResult
} ];

router.addRoutes( routeList );

export default router;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/router.js